import Api from "../api";
let uri = '/api/ed/paquete';

export const getPaqueteCursos = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}/list`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const getPaqueteDetalle = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}/list`, data)
    .then((resp) => {
      const paquete = resp.data?.[0] || null;
      if (paquete?.cursos) {
        paquete.cursos = paquete.cursos.filter(curso => Boolean(curso.estado));
      }
      return paquete;
    })
    .catch((error) =>
        console.log(error)
    );
}

export const adminPaquetes = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const asignPaquete = (data) => {
  return Api.getInstance()
    .executeQuery(uri + "/asignacion", data)
    .then((res) => res.data);
};


export const getPaquetesUsuario = (data) => {
  return Api.getInstance()
    .executeQuery(uri + "/usuario", data)
    .then((res) => res.data);
};

export const postProgresoPaquete = (data) => {
  return Api.getInstance()
    .executeQuery(uri + "/progreso", data)
    .then((res) => res.data);
};


